import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// Ícones para deixar bonito
import { FaUserTie, FaMicrophone, FaCalendarAlt, FaPlay, FaPlusCircle, FaListUl, FaExternalLinkAlt } from "react-icons/fa";
// Importa o novo CSS
import "../styles/painelEntrada.css";

const PainelEntrada = () => {
  const navigate = useNavigate();
  const profissional = JSON.parse(localStorage.getItem("profissional"));

  const [evento, setEvento] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [categoriasSelecionadas, setCategoriasSelecionadas] = useState([]);
  const [rodizios, setRodizios] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [loading, setLoading] = useState(false);

  // Form state
  const [form, setForm] = useState({
    senhaInicial: "",
    senhaFinal: "",
    tamanhoRodizio: "10",
    qtdBois: "4"
  });

  // 1. Setup inicial
  useEffect(() => {
    if (!profissional) {
      navigate("/profissionais/acesso");
      return;
    }

    carregarEvento();
    carregarCategorias();
    listarRodizios();
    
    const intervalo = setInterval(listarRodizios, 5000); // Polling a cada 5s
    return () => clearInterval(intervalo);
  }, []);

  // 2. Buscas
  const carregarEvento = async () => {
    try {
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/events/${profissional.eventoId}`
      );
      setEvento(res.data);
    } catch (error) { console.error(error); }
  };

  const carregarCategorias = async () => {
    try {
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/events/${profissional.eventoId}/categorias`
      );
      setCategorias(res.data);
    } catch (error) { console.error(error); }
  };

  const listarRodizios = async () => {
    try {
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/rodizio/listar/${profissional.eventoId}`
      );
      if (res.data.ok) setRodizios(res.data.rodizios);
    } catch (error) { console.error(error); }
  };

  // 3. Lógica UI
  const toggleCategoria = (nome) => {
    setCategoriasSelecionadas((prev) => {
      if (prev.includes(nome)) return prev.filter((c) => c !== nome);
      return [...prev, nome];
    });
  };

  const handleCriarRodizio = async () => {
    if (categoriasSelecionadas.length === 0) return alert("Selecione uma categoria!");
    if (!form.senhaInicial || !form.senhaFinal) return alert("Preencha as senhas!");

    setLoading(true);
    try {
      const payload = {
        eventoId: profissional.eventoId,
        categorias: categoriasSelecionadas,
        senhaInicial: form.senhaInicial,
        senhaFinal: form.senhaFinal,
        tamanhoRodizio: form.tamanhoRodizio,
        boisParaClassificar: form.qtdBois,
        operador: { nome: profissional.nome, funcao: profissional.funcao }
      };

      await axios.post("https://api.ticketdovaqueiro.com/api/rodizio/iniciar", payload);
      
      setModalAberto(false);
      setCategoriasSelecionadas([]);
      setForm({ senhaInicial: "", senhaFinal: "", tamanhoRodizio: "10", qtdBois: "4" });
      listarRodizios();
      alert("✅ Rodízio iniciado!");
    } catch (error) {
      alert("Erro: " + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const abrirRodizio = (r) => {
    const dadosOperador = {
        ...profissional,
        eventoId: r.eventoId,
        categoria: r.categoria,
        senhaInicial: r.senhaInicial,
        senhaFinal: r.senhaFinal,
        tamanhoRodizio: r.tamanhoRodizio,
        boisParaClassificar: r.boisParaClassificar
    };
    
    localStorage.setItem("painelOperador", JSON.stringify(dadosOperador));
    navigate("/painel/rodizio");
  };

  // Ícone da função
  const IconeFuncao = profissional?.funcao?.includes("locutor") ? FaMicrophone : FaUserTie;

  if (!evento) return <div className="pe-container">Carregando painel...</div>;

  return (
    <div className="pe-container">
      
      {/* --- HEADER --- */}
      <header className="pe-header">
        <h2><FaPlay /> Painel de Controle</h2>
        <div className="pe-info-grid">
            <div className="pe-info-item">
                <small>Profissional</small>
                <span><IconeFuncao style={{marginRight:5}} /> {profissional.nome}</span>
            </div>
            <div className="pe-info-item">
                <small>Função</small>
                <span>{profissional.funcao?.toUpperCase().replace("_", " ")}</span>
            </div>
            <div className="pe-info-item">
                <small>Evento</small>
                <span><FaCalendarAlt style={{marginRight:5}} /> {evento.nome || evento.nomeEvent}</span>
            </div>
        </div>
      </header>

      {/* --- BOX DE AÇÃO --- */}
      <section className="pe-acao-box">
        <h3><FaPlusCircle /> Iniciar Nova Rodada</h3>
        <p className="pe-instrucao">Toque nas categorias para selecionar (pode misturar):</p>
        
        <div className="pe-cat-grid">
            {categorias.map((cat) => (
                <label 
                  key={cat._id || cat.nome} 
                  className={`pe-cat-label ${categoriasSelecionadas.includes(cat.nome) ? 'selected' : ''}`}
                >
                    <input 
                        type="checkbox" 
                        value={cat.nome}
                        checked={categoriasSelecionadas.includes(cat.nome)}
                        onChange={() => toggleCategoria(cat.nome)}
                    />
                    {cat.nome}
                </label>
            ))}
        </div>

        <button 
            className="pe-btn-main" 
            disabled={categoriasSelecionadas.length === 0}
            onClick={() => setModalAberto(true)}
        >
            Configurar e Iniciar ({categoriasSelecionadas.length})
        </button>
      </section>

      {/* --- TABELA DE RODÍZIOS --- */}
      <section className="pe-table-wrapper">
        <div style={{padding: "15px", borderBottom: "1px solid #333", background:"#2a2a2a"}}>
            <h3 style={{margin:0, color:"#fdd212", display:"flex", alignItems:"center", gap:8}}>
                <FaListUl /> Rodízios Ativos
            </h3>
        </div>
        
        {rodizios.length === 0 ? (
            <div style={{padding:30, textAlign:"center", opacity:0.7}}>
                Nenhum rodízio ativo no momento.
            </div>
        ) : (
            <table className="pe-table">
                <thead>
                    <tr>
                        <th>Categorias</th>
                        <th>Faixa Senhas</th>
                        <th>Status</th>
                        <th>Fila</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody>
                    {rodizios.map((r) => (
                        <tr key={r._id}>
                            <td data-label="Categorias">{r.categoria}</td>
                            <td data-label="Faixa">{r.senhaInicial} a {r.senhaFinal}</td>
                            <td data-label="Status">
                                <span className={`pe-badge ${r.status === 'ATIVO' ? 'ativo' : 'encerrado'}`}>
                                    {r.status}
                                </span>
                            </td>
                            <td data-label="Fila Restante">
                                <b style={{color:"#fff"}}>{r.fila ? r.fila.length : 0}</b> senhas
                            </td>
                            <td data-label="Ação">
                                <button className="pe-btn-abrir" onClick={() => abrirRodizio(r)}>
                                    Abrir Painel <FaExternalLinkAlt />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        )}
      </section>

      {/* --- MODAL --- */}
      {modalAberto && (
        <div className="pe-modal-overlay">
          <div className="pe-modal">
            <h3>Configurar Rodízio</h3>
            <p style={{fontSize: "0.9rem", color:"#aaa", marginBottom: 20}}>
                Categorias: <b style={{color:"#fdd212"}}>{categoriasSelecionadas.join(" + ")}</b>
            </p>
            
            <div className="pe-form-group">
                <label>Senha Inicial:</label>
                <input 
                    type="number" className="pe-input" placeholder="Ex: 1"
                    value={form.senhaInicial} 
                    onChange={e => setForm({...form, senhaInicial: e.target.value})} 
                />
            </div>
            
            <div className="pe-form-group">
                <label>Senha Final:</label>
                <input 
                    type="number" className="pe-input" placeholder="Ex: 50"
                    value={form.senhaFinal} 
                    onChange={e => setForm({...form, senhaFinal: e.target.value})} 
                />
            </div>

            <div style={{display:"flex", gap:10}}>
                <div className="pe-form-group" style={{flex:1}}>
                    <label>Tamanho Rodízio:</label>
                    <input 
                        type="number" className="pe-input"
                        value={form.tamanhoRodizio} 
                        onChange={e => setForm({...form, tamanhoRodizio: e.target.value})} 
                    />
                </div>
                <div className="pe-form-group" style={{flex:1}}>
                    <label>Classificar (Bois):</label>
                    <input 
                        type="number" className="pe-input"
                        value={form.qtdBois} 
                        onChange={e => setForm({...form, qtdBois: e.target.value})} 
                    />
                </div>
            </div>

            <div className="pe-modal-actions">
                <button className="pe-btn-cancel" onClick={() => setModalAberto(false)}>
                    Cancelar
                </button>
                <button className="pe-btn-confirm" onClick={handleCriarRodizio} disabled={loading}>
                    {loading ? "Criando..." : "INICIAR"}
                </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PainelEntrada;